import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateLeadsViews } from '../../../lib/query/invalidateResource';
import { addLeadActivity } from '../api/leads';
import type { LeadActivityFormValues } from '../types';
import { notification } from 'antd';

interface AddActivityPayload {
  leadId: string;
  values: LeadActivityFormValues;
}

export function useAddLeadActivity() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ leadId, values }: AddActivityPayload) =>
      addLeadActivity(leadId, values),
    onSuccess: (_, variables) => {
      notification.success({ message: 'Activity added' });
      invalidateLeadsViews(queryClient);
      void queryClient.invalidateQueries({ queryKey: ['lead', variables.leadId] });
    },
    onError: () => {
      notification.error({ message: 'Failed to add activity' });
    },
  });
}
